import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { InputLabel, MenuItem, Select, alpha, inputLabelClasses, styled } from '@mui/material';
import { RookeryRegularFont } from 'v3/styles/common';
import { theme } from 'v3/styles/global-styles';

export const StyledArrowDropDownIcon = styled(KeyboardArrowDown)(() => ({
  color: theme.palette.common.white,
  cursor: 'pointer',
}));

export const StyledArrowDropUpIcon = styled(KeyboardArrowUp)(() => ({
  color: theme.palette.common.white,
  cursor: 'pointer',
}));

export const selectMenuPaperPropsStyle = {
  style: {
    backgroundColor: `${theme.palette.primary.main}`,
    border: 'none',
    borderRadius: '0.5rem',
    padding: '0.5rem, 1.5rem, 0.5rem, 1.5rem',
    maxHeight: '13.875rem',
  },
};

export const StyledSelect = styled(Select)(({ theme, fullWidth }) => ({
  width: fullWidth ? '100%' : '13rem',
  height: '3rem',
  borderBottom: `.1rem solid ${theme.palette.secondary.light}`,
  color: theme.palette.common.white,
  borderRadius: '0',
  flexGrow: 1,
  marginBottom: '1rem',
  paddingLeft: '0',
  font: RookeryRegularFont,

  '& fieldset': {
    border: 'none',
  },
  '&:hover': {
    borderBottom: `.1rem solid ${theme.palette.secondary.light}`,
  },
  '&.Mui-selected': {
    backgroundColor: alpha(theme.palette.primary.light, 0.6),
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  height: '3rem',
  color: theme.palette.common.white,
  backgroundColor: `${theme.palette.primary.main}`,
  font: RookeryRegularFont,
  flexGrow: 1,
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.light, 0.6),
  },
}));

export const InputLabelStyled = styled(InputLabel)(({ theme }) => ({
  color: alpha(theme.palette.common.white, 0.6),
  left: '-0.875rem ',

  [`&.${inputLabelClasses.focused}`]: {
    color: alpha(theme.palette.common.white, 0.6),
  },
}));
